import ArticleInterface from '@app/Interface/ArticleInterface';
import EmbeddedFileInterface from '@app/Interface/EmbeddedFileInterface';
import { Card, CardTitle, CardBody, CardFooter, CardHeader, Label, Flex, FlexItem } from '@patternfly/react-core';
import * as React from 'react';
import { Link } from 'react-router-dom';
import ArticleImage from '@app/Components/Article/ArticleImage';
import { InfoCircleIcon } from '@patternfly/react-icons';
import ArticleHelper from '@app/Service/ArticleHelper';
import htmlParser from '@app/utils/htmlParser';

interface ArticleItemProps {
    article: ArticleInterface,
    path: string
}

const ArticleItem: React.FC<ArticleItemProps> = ({ article, path }) => {

    let featuredImage: EmbeddedFileInterface | null = null;

    if (typeof article.featuredImage === "object") {
        featuredImage = article.featuredImage;
    }

    return (

        <Card className="pf-u-mb-xl">
            <Flex spaceItems={{ default: 'spaceItemsNone' }} alignItems={{ default: 'alignItemsStretch' }}>
                {featuredImage &&
                    <FlexItem flex={{ default: "flex_1" }}>
                        {featuredImage && <ArticleImage featuredImage={featuredImage} />}
                    </FlexItem>
                }
                <FlexItem flex={{ default: "flex_2" }}>
                    {ArticleHelper.isNewArticle(article, 2) &&
                        <CardHeader>
                            <Label variant="outline" color="red" icon={<InfoCircleIcon />}>
                                New!
                            </Label>
                        </CardHeader>
                    }
                    <CardHeader>
                        {article.date.toDateString()}
                    </CardHeader>
                    <CardTitle>
                        <Link to={{ pathname: path, search: `?article=${article.slug}`}}>{article.title}</Link>
                    </CardTitle>
                    <CardBody>
                        <div className="pf-c-content">
                            {htmlParser.htmlToJSX(article.excerpt ?? '')}
                        </div>
                    </CardBody>
                    <CardBody>
                        <div>
                            <Link to={{ pathname: path, search: `?article=${article.slug}`}}>Read Article</Link>
                        </div>
                    </CardBody>
                    {article.categories &&
                        <CardFooter>
                            <span>Category:</span>
                            {article.categories.map((category) => (
                                <Label
                                    className="pf-u-mx-xs"
                                    key={category.id}
                                    render={() => (
                                        <Link to={{ pathname: path, search: `?cat=${category.slug}`}}>{category.name}</Link>
                                    )}
                                ></Label>
                            ))}
                        </CardFooter>
                    }
                </FlexItem>
            </Flex>
        </Card>


    );

}

export default ArticleItem